<div class="wrapper">
  <div class="dialog-head">
    <h2>Печать штрих-кода</h2>
    <p *ngIf="productTitle">{{ productTitle }} · ID {{ productId }}</p>
    <p *ngIf="!productTitle && productId">Товар ID {{ productId }}</p>
  </div>
  <form (ngSubmit)="print()" [formGroup]="labelFrom" class="drop-padding">
    <mat-form-field appearance="outline">
      <mat-label>Агент печати</mat-label>
      <mat-select formControlName="agentTargetId">
        <mat-option *ngFor="let computer of computers" [value]="computer.targetId">{{ computer.label }}</mat-option>
      </mat-select>
      <mat-hint>{{ loadingTargets ? 'Загружаем агенты…' : 'Принтер этикеток выбранного агента' }}</mat-hint>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Количество штрих-кодов</mat-label>
      <input matInput formControlName="quanPrint" type="number" min="1" step="1" [readonly]="printing" />
      <mat-error>Укажите целое количество, не меньше 1</mat-error>
    </mat-form-field>
    <p class="print-error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
    <div class="dialog-actions">
      <button mat-button type="button" (click)="loadTargets()" [disabled]="loadingTargets || printing">Обновить агенты</button>
      <button mat-button type="button" (click)="close()" [disabled]="printing">Отмена</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="printing || loadingTargets || labelFrom.invalid || !computers.length">
        {{ printing ? 'Отправляем…' : 'Печать' }}
      </button>
    </div>
  </form>
</div>
